import { ISignUpRequest } from '@faire/web-api--source/indigofair/data/ISignUpRequest';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * This is the prioritized list to determine the primary business platform of a retailer on sign up
 * https://www.notion.so/faire/Onboarding-flow-revamp-fa8bf5c1cd464d4fbc4472984154ac0f?pvs=4
 */
export const RETAILER_PRIORITIZED_BUSINESS_PLATFORMS_ON_SIGN_UP =
  'RETAILER_PRIORITIZED_BUSINESS_PLATFORMS_ON_SIGN_UP' as SettingConst<
    'RETAILER_PRIORITIZED_BUSINESS_PLATFORMS_ON_SIGN_UP',
    Array<keyof typeof ISignUpRequest.BusinessPlatform>,
    'RETAILER' | 'VISITOR_WEB'
  >;
